import Swiper from 'swiper';
import { ScrollCaptain } from 'scroll-captain';

class Usp {
    constructor(element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-research-ai-landingpage-usp',
            sliderValue: 'slider',
            numverValue: 'number',
            charValue: 'char',
            itemValue: 'item',
            item1Value: 'item-1',
            item2Value: 'item-2',
            item3Value: 'item-3',
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);
        this.resizeHandler = window.resizeHandler;
        this.slider = null;
        this.sliderIsActive = false;

        // Elements
        this.$usp = element;
        this.charAnimation = null;
        this.itemAnimation = null;
        this.$slider = this.$usp.querySelector(`[${ this.settings.initAttr }="${ this.settings.sliderValue }"]`);
        this.$$slides = this.$usp.querySelectorAll(`[${ this.settings.initAttr }^="${ this.settings.itemValue }"]`);
        this.$$numbers = this.$usp.querySelectorAll(`[${ this.settings.initAttr }^="${ this.settings.numverValue }"]`);
    }

    initialize() {
        if (this.$slider) {
            if (this.$$slides.length > 1) {
                this.checkSize();
                this.resizeHandler.customFunctions.push(() => {
                    this.checkSize();
                });
            }

            if (this.$$numbers.length > 0) {
                this.$$numbers.forEach($number => {
                    this.prepareNumbers($number);
                });
            }

            this.initItemAnimation();
        }
    }

    prepareNumbers(element) {
        if (!element || !element.textContent) {return;}

        const characters = element.textContent.split('');

        element.textContent = '';

        characters.forEach(char => {
            const span = document.createElement('span');
            span.setAttribute(this.settings.initAttr, this.settings.charValue);
            span.textContent = char;
            element.appendChild(span);
        });
    }

    initItemAnimation() {
        const defaultOptions = {
            onscroll: true,
            duration: 0,
            easing: 'linear',
        };

        if (window.innerWidth >= 768) {
            this.charAnimation = new ScrollCaptain(this.$slider, {
                initAttr: this.settings.initAttr,
                bottom: '-40%',
                animateChar: {
                    targetSuffix: this.settings.charValue,
                    delay: { time: 1, multiplier: 0.05 },
                    duration: 0.4,
                    easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
                    translateY: { 0: -100, 100: 0 },
                    resetOnScrollDown: false,
                    resetOnScrollUp: false,
                },
            });

            this.itemAnimation = new ScrollCaptain(this.$slider, {
                initAttr: this.settings.initAttr,
                top: '70%',
                animateItem1: {
                    ...defaultOptions,
                    targetSuffix: this.settings.item1Value,
                },
                animateItem2: {
                    ...defaultOptions,
                    targetSuffix: this.settings.item2Value,
                },
                animateItem3: {
                    ...defaultOptions,
                    targetSuffix: this.settings.item3Value,
                },
                breakpoints: {
                    768: {
                        animateItem1: {
                            ...defaultOptions,
                        },
                        animateItem2: {
                            ...defaultOptions,
                            translateX: { 0: -200, 100: 0 },
                            scale: { 0: 1.05, 100: 1 },
                        },
                        animateItem3: {
                            ...defaultOptions,
                            translateX: { 0: -400, 100: 0 },
                            scale: { 0: 1.1, 100: 1 },
                        },
                    },

                },
            });
        }
    }

    checkSize() {
        if (window.innerWidth < 768) {
            if (this.sliderIsActive === false) {
                this.initSlider();
                this.sliderIsActive = true;
            }
        } else {
            if (this.sliderIsActive === true) {
                this.destroySlider();
                this.sliderIsActive = false;
            }
        }
    }

    destroySlider() {
        if (typeof this.slider !== 'undefined' && this.slider !== null) {
            this.slider.destroy();
        }
    }

    initSlider() {
        this.slider = new Swiper(this.$slider, {
            speed: 500,
            effect: 'fade',
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            centeredSlides: true,
            centeredSlidesBounds: true,
            spaceBetween: 16,
            draggable: true,
        });
    }
}

export { Usp };
